export const handlePDFClick = (e) => {
    window.open(e.target.value, '_blank');
};
